import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/sports-island/construction/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/sports-island/construction',
  name: 'activity_sports_island_construction',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '运动岛创岛大赛',
    expiryDate: '2024-09-05',
  },
}

export default []
